module.exports = __webpack_public_path__ + "img/reservations.a6368b5e.svg";